import React, { type HTMLAttributes, useContext } from 'react';
import styled from 'styled-components';
import type { VariantPickerListItem } from 'autogen/swagger/all';
import SwatchRenderer from '../../Swatches/SwatchRenderer';
import { SelectionCallbackContext } from '../shared/context/selectionCallback';

// #region Styles
const Label = styled.label`
    display: flex;
    margin: 0;
`;

const Input = styled.input`
    opacity: 0;
    width: 0;
    height: 0;
`;
// #endregion Styles

type HorizontalItemProps = {
    item: VariantPickerListItem;
    radioGroupName: string;
};

export default function HorizontalItem({
    item,
    radioGroupName,
    ...restProps
}: HorizontalItemProps & HTMLAttributes<HTMLLabelElement>): JSX.Element {
    const { isSelected } = item;
    const onCheckedCallback = useContext(SelectionCallbackContext);

    return (
        <Label {...restProps}>
            <Input
                type="radio"
                name={radioGroupName}
                checked={isSelected}
                onChange={() => {
                    if (onCheckedCallback) {
                        onCheckedCallback(item.productId);
                    }
                }}
            />
            <SwatchRenderer {...{ ...item, linkAction: undefined, size: item.displayType === 'Image' ? 'sm' : 'lg' }} />
        </Label>
    );
}
